import toast from "react-hot-toast";

//old version
const API = "127.0.0.1/api-chiksoft";
// const API = "http://localhost:8600";
// const API = "https://api-chiksoft.buzconapp.com";

// export const URL_BACKEND_APP = "https://www.api.etpm.chiksoft.com/api/";
// export const URL_BACKEND_APP = "http://api-chiksoft-optimal.50webs.org/api/";
// export const URL_BACKEND_APP = "http://localhost/api-chiksoft";
// export const URL_BACKEND_APP = "https://api.chicksoft.50webs.org";
// export const URL_BACKEND_APP = "https://api.test.chiksoft.com/api/"; //last update 2026-29-09
export const URL_BACKEND_APP = "https://api.etpm.chiksoft.com/api/"; //last update 2026-29-09
export const PREFIX = {
  SCHOOL_NAME: "ETPM",
  APP_NAME: "CHIK SOFT",
  APP_VERSION: "1.0.0",
};

export const EHULA_CONTACT = {
  PHONE: "+243990119611",
  EMAIL: "info.ehula@gmail.com",
};

export const ANNEE_SCOLAIRE = [
  "2021-2022",
  "2022-2023",
  "2023-2024",
  "2024-2025",
];

//id 1=2024-2025
//id 2=2025-2026
//id 3=2026-2027
export const ANNEE_SCOLAIRE_ID = [1];

export const NOTIFY = {
  success: (msg) => toast.success(msg),
  error: (msg) => toast.error(msg),
  dismiss: (msg) => toast.dismiss(msg),
  loading: (msg) => toast.loading(msg),
};

export default API;
